export enum EventVariant {
  BASE = 'baseEvent',
  SKIP = 'skipEvent',
  CLICK = 'clickEvent',
  GET_OFFER = 'getOfferEvent',
}

export type EventProperties = Record<string, unknown>;

export type ExtendedEventValue = {
  name: string;
  properties: EventProperties;
};

export type EventValue = ExtendedEventValue | string;

export type AmplitudeAnalyticsEvent = Record<EventVariant, EventValue>;

export const isExtendedEvent = (event: EventValue): event is ExtendedEventValue => {
  return typeof event !== 'string';
};

export type EventUserProperty = number | string | boolean | Array<string | number>;
